import { render } from "./SidebarLeft.vue?vue&type=template&id=a1a7ad52&scoped=true"
import script from "./SidebarLeft.vue?vue&type=script&lang=js"
export * from "./SidebarLeft.vue?vue&type=script&lang=js"

import "./SidebarLeft.vue?vue&type=style&index=0&id=a1a7ad52&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1a7ad52"]])

export default __exports__